(function () {
  function readJSON(root, sel, fallback) {
    var el = root.parentNode.querySelector(sel);
    try { return el ? JSON.parse(el.textContent) : fallback; } catch (e) { return fallback; }
  }
  function lines(str, sep) {
    var out = {};
    (str || '').split(/\n/).forEach(function (line) {
      var i = line.indexOf(sep); if (i < 1) return;
      out[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
    });
    return out;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  var LABELS = {
    shop: { men: "Men's", women: "Women's", all: 'All fits' },
    style: { classic: 'Classic log', performance: 'Modern longboard', both: 'Log + modern' },
    fins: { single: 'Single fin', thruster: '2+1 / three fin', any: 'Any fin' },
    stance: { regular: 'Regular', goofy: 'Goofy' },
    leash: { leash: 'Leash', noleash: 'No leash', depends: 'Leash depends' },
    water: { wetsuit: 'Wetsuit', trunks: 'Trunks', both: 'Wetsuit + trunks' },
    colour: { muted: 'Muted colours', bright: 'Brighter colours' }
  };
  var BODY_NOTES = {
    'Side Pocket': 'Brushed organic cotton. Hidden side-seam pockets for keys and wax.',
    'Mid-Weight': 'Fleece-back organic cotton. The one for cold car parks.',
    'Raglan': 'No shoulder seam, so it goes on easily over wet arms. XS–3XL.',
    'Crewneck': 'No hood, same organic cotton. For the drive home.'
  };
  var RANK = ['Side Pocket', 'Mid-Weight', 'Raglan', 'Crewneck'];
  var ORDER = ['shop', 'style', 'fins', 'stance', 'leash', 'water', 'colour'];
  var PAGE = 6;

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var products = readJSON(root, '[data-otw-products]', []);
    var artwork = readJSON(root, '[data-otw-artwork]', {});
    var aliases = lines(root.dataset.aliases, '=');
    var traitMap = {};
    var rawTraits = lines(root.dataset.traits, ':');
    Object.keys(rawTraits).forEach(function (k) {
      traitMap[k] = rawTraits[k].split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
    });

    var designs = {};
    products.forEach(function (p) {
      var key = aliases[p.design.toLowerCase()] || p.design;
      if (!designs[key]) designs[key] = { name: key, items: [], tags: [] };
      designs[key].items.push(p);
      (p.tags || []).forEach(function (t) {
        t = String(t).toLowerCase();
        if (t.indexOf('fit:') === 0 && designs[key].tags.indexOf(t.slice(4)) < 0) designs[key].tags.push(t.slice(4));
      });
    });
    Object.keys(designs).forEach(function (k) {
      if (!designs[k].tags.length) designs[k].tags = traitMap[k.toLowerCase()] || [];
    });

    var hero = root.querySelector('[data-hero]');
    var stage = root.querySelector('[data-stage]');
    var results = root.querySelector('[data-results]');
    var bar = root.querySelector('.otw-quiz__progress span');
    var imgs = root.querySelectorAll('.otw-stage__img');
    var answers = {};
    var current = 'intro';

    function scrollTop() {
      var top = root.getBoundingClientRect().top + window.scrollY - 60;
      if (Math.abs(window.scrollY - top) > 40) window.scrollTo({ top: top, behavior: 'smooth' });
    }

    var header = document.querySelector('#header-component');
    var headerMode = header ? header.getAttribute('transparent') : null;
    function syncHeader(name) {
      if (!header || !headerMode) return;
      if (name === 'intro') header.setAttribute('transparent', headerMode);
      else header.removeAttribute('transparent');
    }

    function show(name) {
      current = name;
      syncHeader(name);
      var isQ = ORDER.indexOf(name) > -1;
      hero.hidden = name !== 'intro';
      stage.hidden = !isQ;
      results.hidden = name !== 'result';
      root.querySelectorAll('.otw-quiz__step').forEach(function (s) { s.classList.toggle('is-active', s.dataset.step === name); });
      if (isQ) {
        var idx = ORDER.indexOf(name);
        bar.style.width = Math.round(idx / ORDER.length * 100) + '%';
        var step = root.querySelector('[data-step="' + name + '"]');
        var want = step && step.dataset.img;
        imgs.forEach(function (im) {
          var on = im.dataset.img === want;
          if (on) im.loading = 'eager';
          im.classList.toggle('is-on', on);
        });
        root.querySelector('[data-back]').hidden = false;
      }
      scrollTop();
    }

    root.querySelector('[data-next]').addEventListener('click', function () { show(ORDER[0]); });
    root.querySelector('[data-back]').addEventListener('click', function () {
      var i = ORDER.indexOf(current);
      show(i > 0 ? ORDER[i - 1] : 'intro');
    });
    root.querySelector('[data-restart]').addEventListener('click', function () {
      answers = {};
      root.querySelectorAll('.is-picked').forEach(function (b) { b.classList.remove('is-picked'); });
      show('intro');
    });

    root.querySelectorAll('[data-q] .otw-quiz__options button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.closest('[data-q]');
        step.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-picked'); });
        btn.classList.add('is-picked');
        answers[step.dataset.q] = btn.dataset.value;
        var next = ORDER[ORDER.indexOf(step.dataset.q) + 1];
        setTimeout(function () {
          if (!next) { renderResult(); show('result'); } else show(next);
        }, 200);
      });
    });

    function profile() {
      var s = answers.style, f = answers.fins, l = answers.leash, w = answers.water;
      if (s === 'classic' && f !== 'thruster' && l === 'noleash')
        return ['The Purist', 'Heavy log, one fin, no leash when the lineup allows. You surf for the walk to the nose, not the photo of it.'];
      if (s === 'classic')
        return ['The Nose Rider', 'You trim, you cross-step, you hang out up front. Style over speed, every session.'];
      if (s === 'performance')
        return ['The Carver', 'A longboard that turns. Rail work, drawn lines, the occasional roundhouse off the whitewater.'];
      if (w === 'wetsuit')
        return ['The Cold Water Local', 'Whatever board fits the day, a thick wetsuit and a long walk back up the beach in the fog.'];
      return ['The All-Rounder', 'Log on small days, something looser when it picks up. You read the day, then choose the board.'];
    }

    function userTraits() {
      var t = [];
      if (answers.style === 'both') t.push('classic', 'performance'); else t.push(answers.style);
      if (answers.fins === 'any') t.push('single', 'thruster'); else t.push(answers.fins);
      t.push(answers.leash === 'depends' ? 'leash' : answers.leash);
      if (answers.water === 'both') t.push('wetsuit', 'trunks'); else t.push(answers.water);
      t.push(answers.colour);
      return t;
    }

    function fits(p) {
      var shop = answers.shop;
      if (!shop || shop === 'all') return true;
      var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      if (!tags.some(function (t) { return t === 'men' || t === 'women' || t === 'unisex'; })) return true;
      return tags.indexOf(shop) > -1 || tags.indexOf('unisex') > -1;
    }

    function recommendedBody() {
      if (answers.water === 'wetsuit') return 'Mid-Weight';
      if (answers.water === 'trunks') return 'Raglan';
      return 'Side Pocket';
    }

    function renderResult() {
      var p = profile();
      root.querySelector('[data-profile-name]').textContent = p[0];
      root.querySelector('[data-profile-desc]').textContent = p[1];
      root.querySelector('[data-profile-chips]').innerHTML = Object.keys(LABELS).map(function (k) {
        return answers[k] ? '<li>' + esc(LABELS[k][answers[k]]) + '</li>' : '';
      }).join('');

      var mine = userTraits();
      var rec = recommendedBody();
      var scores = {};
      Object.keys(designs).forEach(function (k) {
        scores[k] = designs[k].tags.filter(function (t) { return mine.indexOf(t) > -1; }).length;
      });
      var best = Math.max.apply(null, Object.keys(scores).map(function (k) { return scores[k]; }).concat([0]));

      var list = [];
      Object.keys(designs).forEach(function (k) {
        designs[k].items.forEach(function (it) { if (fits(it)) list.push({ p: it, design: k, score: scores[k] }); });
      });
      list.sort(function (a, b) {
        return (b.score - a.score) ||
          ((b.p.body === rec) - (a.p.body === rec)) ||
          (RANK.indexOf(a.p.body) - RANK.indexOf(b.p.body)) ||
          a.design.localeCompare(b.design);
      });

      var grid = root.querySelector('[data-products]');
      grid.innerHTML = list.map(function (x, i) {
        var p = x.p, badge = '';
        var topDesign = x.score > 0 && x.score === best;
        if (topDesign && p.body === rec) badge = 'Top pick';
        else if (topDesign) badge = 'Your match';
        else if (p.body === rec) badge = 'Best for your water';
        return '<a class="otw-card" href="' + esc(p.url) + '"' + (i >= PAGE ? ' hidden' : '') + '>' +
          (badge ? '<span class="otw-card__badge">' + badge + '</span>' : '') +
          (p.image ? '<img class="otw-card__photo" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          '<span class="otw-card__body"><span class="otw-card__tag">' + esc(p.body) + '</span>' +
          '<span class="otw-card__name">' + esc(x.design) + ' \u00b7 ' + esc(p.price) + '</span>' +
          '<span class="otw-card__meta">' + esc(BODY_NOTES[p.body] || '') + '</span></span></a>';
      }).join('') || '<p class="otw-quiz__hint">Nothing in this fit yet. New pieces are on the way.</p>';

      var more = root.querySelector('[data-more]');
      more.hidden = list.length <= PAGE;
      more.textContent = 'Show all ' + list.length;
      more.onclick = function () {
        grid.querySelectorAll('.otw-card[hidden]').forEach(function (c) { c.hidden = false; });
        more.hidden = true;
      };

      var tagInput = root.querySelector('[data-tags]');
      if (tagInput) {
        var tags = ['newsletter', 'style-quiz', 'profile:' + p[0].replace(/^The /, '').toLowerCase().replace(/\s+/g, '-')];
        Object.keys(LABELS).forEach(function (k) { if (answers[k]) tags.push(k + ':' + answers[k]); });
        tagInput.value = tags.join(',');
      }
    }

    var KEY = 'otw-quiz-answers';
    var form = root.querySelector('#otw-offer-form');
    if (form) form.addEventListener('submit', function () {
      try { sessionStorage.setItem(KEY, JSON.stringify(answers)); } catch (e) {}
    });
    var posted = root.querySelector('.otw-save__ok, .otw-save__err') || /customer_posted=true/.test(location.search);
    if (posted) {
      var saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
      if (saved && saved.style) {
        answers = saved;
        Object.keys(answers).forEach(function (q) {
          var b = root.querySelector('[data-q="' + q + '"] button[data-value="' + answers[q] + '"]');
          if (b) b.classList.add('is-picked');
        });
        renderResult();
      }
      show('result');
      var offer = root.querySelector('[data-offer]');
      if (offer) setTimeout(function () { offer.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
    }
  }

  function boot() { document.querySelectorAll('.otw-quiz').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
